export default "__VITE_ASSET__Du_$tE_g__"